import { useAtom } from 'jotai'
import type { AppProps } from 'next/app'

import * as React from 'react'
import { wCheckKYCStatusAtom } from '../atoms/CreatorCheck'
import useAuth from '../hooks/auth'

function Root({ Component, pageProps }: Omit<AppProps, 'router'>): any {
  const [, checkKYCStatus] = useAtom(wCheckKYCStatusAtom)
  const { isAuthenticated } = useAuth()
  React.useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    // start checking creator only after successful firebase auth
    checkKYCStatus()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  return <Component {...pageProps} />
}

export default Root
